import { updateContact } from 'legacy/lut/services/contacts/updateContact'

import { fetchContactsWithSameRole_old } from '../../../../../services/contacts/fetchContactsWithSameRole_old'
import { UNIQUE_VALUES_LIST } from '../configs'

export const removeUniqueHpRolesFromOtherContacts = async ({
  newRoles,
  partnerId,
  contactId,
  userEmail,
  appSource,
  callback,
}: {
  newRoles: string[]
  partnerId: string
  contactId: string
  userEmail: string
  callback: () => Promise<boolean>
  appSource?: string
}) => {
  const isNotUpdated = await callback()

  for (const role of newRoles) {
    if (UNIQUE_VALUES_LIST.includes(role)) {
      const contacts = await fetchContactsWithSameRole_old({ contactId, partnerId, role })

      for (const contact of contacts) {
        const newHpRoles = contact.hpRoles.filter((value) => value !== role)
        const newModifiedData = contact.modifiedValues.includes('PR_HP_ROLE')
          ? contact.modifiedValues
          : [...contact.modifiedValues, 'PR_HP_ROLE']

        await updateContact({
          contact: { ...contact, hpRoles: newHpRoles, modifiedValues: newModifiedData },
          source: appSource,
          sourceRequester: userEmail,
        })
      }
    }
  }

  return isNotUpdated
}
